import '@axmit/garwin-api';
import { IRequestSuccess } from 'common/models';

export interface ICityCollectionParams extends Paths.CityControllerList.QueryParameters {}
export interface ICityCollection extends Components.Schemas.CityCollectionDto {}

export interface ICity extends Components.Schemas.CityDto {}

export interface ICreateCity extends Components.Schemas.CreateCityDto, IRequestSuccess {}
export interface IUpdateCity extends Components.Schemas.UpdateCityDto, IRequestSuccess {
  id: number;
}

export const cityListIsAvailableOptions = [
  {
    label: 'Все города',
    value: 'all',
  },
  { type: 'divider' },
  {
    label: 'Доступные',
    value: true,
  },
  { type: 'divider' },
  {
    label: 'Недоступные',
    value: false,
  },
];
